// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1HT-I","box":"WorkspacesBox_box__3BZcQ","node":"WorkspacesBox_node__1Qdo-"};